import React from 'react';
import { Row, Col } from 'antd';

import Card, { CardItem } from './Card';
import AMD from '../../../common/amd/AMD';

import {formatAmount} from "../../../helpers/parsers";

const Conditions = ({application}) => {
    const {
        landerName,
        loan,
        monthlyServiceFeeInGracePeriod,
        monthlyServiceFeeAfterGracePeriod,
        monthlyPaymentInGracePeriod2,
        monthlyPaymentAfterGracePeriod,
    } = application;

    const { prepayment, interestRate, amount, gracePeriod, effectiveRate, serviceInterestRate , subsidyInterest} = loan || {};

    return (
        <Card title='Վարկի պայմաններ'>
            <div className='rounded-container mt-1'>
                <div>
                    <Row justify='space-between' className='table-header-big big border-b-white'>
                        <Col style={{ fontSize: 20, padding: '24px' }}>{landerName}</Col>
                        <Col>
                            <CardItem
                                style={{ padding: '24px', textAlign: 'right' }}
                                name='Գումար'
                                value={
                                    <div className='big-purple-text'>
                                        <AMD value={amount || 0}/>
                                    </div>
                                }
                            />
                        </Col>
                    </Row>
                </div>
                <div className='table-header'>
                    <Row className='h-100'>
                        <Col className='my-auto px-2'>Վարկի պայմաններ</Col>
                    </Row>
                </div>
                <div>
                    <Row className='border-b table-row' justify='space-between'>
                        <Col className='my-auto px-2'>Կանխավճար</Col>
                        <Col style={{ fontWeight: 'bold', color: '#191d21', fontSize: '16px' }} className='my-auto px-2'>
                            <AMD value={prepayment || 0}/>
                        </Col>
                    </Row>
                    <Row className='border-b table-row' justify='space-between'>
                        <Col className='my-auto px-2'>Տոկոսադրույք</Col>
                        {gracePeriod && gracePeriod.gracePeriodForInterestRate ? (
                            <>
                                <Col className='my-auto px-2'>
                                    մինչև&nbsp;
                                    <span style={{ fontWeight: 'bold', color: '#191d21', fontSize: '16px' }}>
                                        {gracePeriod.gracePeriodForInterestRate}
                                    </span>
                                    &nbsp;ամիս&nbsp;
                                    <span style={{ fontWeight: 'bold', color: '#191d21', fontSize: '16px' }}>
                                        {gracePeriod.interestRateInGracePeriod}
                                    </span>
                                    &nbsp;%
                                </Col>
                                <Col className='my-auto px-2'>
                                    <span style={{ fontWeight: 'bold', color: '#191d21', fontSize: '16px' }}>
                                        {gracePeriod.gracePeriodForInterestRate + 1}
                                    </span>
                                    -րդ ամսից&nbsp;
                                    <span style={{ fontWeight: 'bold', color: '#191d21', fontSize: '16px' }}>
                                        {interestRate}
                                    </span>
                                    &nbsp;%
                                </Col>
                            </>
                        ) : (
                            <Col style={{ fontWeight: 'bold', color: '#191d21', fontSize: '16px' }} className='my-auto px-2'>
                                {interestRate ? `${interestRate}%` : '-'}
                            </Col>
                        )}
                    </Row>
                    {
                        subsidyInterest && <Row className='border-b table-row' justify='space-between'>
                            <Col className='my-auto px-2'>Սուբսիդավորման տոկոս</Col>
                            <Col style={{ fontWeight: 'bold', color: '#191d21', fontSize: '16px' }} className='my-auto px-2'>
                                {subsidyInterest}%
                            </Col>
                        </Row>
                    }
                    <Row className='border-b table-row' justify='space-between'>
                        <Col className='my-auto px-2'>Սպասարկման վճար</Col>
                        {gracePeriod && gracePeriod.gracePeriodForInterestRate ? (
                            <>
                                <Col className='my-auto px-2'>
                                    մինչև&nbsp;
                                    <span style={{ fontWeight: 'bold', color: '#191d21', fontSize: '16px' }}>
                                        {gracePeriod.gracePeriodForInterestRate}
                                    </span>
                                    &nbsp;ամիս&nbsp;
                                    <span style={{ fontWeight: 'bold', color: '#191d21', fontSize: '16px' }}>
                                        {formatAmount(monthlyServiceFeeInGracePeriod)}
                                        &nbsp;֏
                                    </span>
                                </Col>
                                <Col className='my-auto px-2'>
                                    <span style={{ fontWeight: 'bold', color: '#191d21', fontSize: '16px' }}>
                                        {gracePeriod.gracePeriodForInterestRate + 1}
                                    </span>
                                    -րդ ամսից&nbsp;
                                    <span style={{ fontWeight: 'bold', color: '#191d21', fontSize: '16px' }}>
                                        {formatAmount(monthlyServiceFeeAfterGracePeriod)}
                                        &nbsp;֏
                                    </span>
                                </Col>
                            </>
                        ) : (
                            <Col style={{ fontWeight: 'bold', color: '#191d21', fontSize: '16px' }} className='my-auto px-2'>
                                <span>{serviceInterestRate}%</span>
                            </Col>
                        )}
                    </Row>
                    <Row className='border-b table-row' justify='space-between'>
                        <Col className='my-auto px-2'>Ամսական մարում</Col>
                        {gracePeriod && gracePeriod.gracePeriodForLoanAmount ? (
                            <>
                                <Col className='my-auto px-2'>
                                    մինչև&nbsp;
                                    <span style={{ fontWeight: 'bold', color: '#191d21', fontSize: '16px' }}>
                                        {gracePeriod.gracePeriodForLoanAmount}
                                    </span>
                                    &nbsp;ամիս&nbsp;
                                    <span style={{ fontWeight: 'bold', color: '#191d21', fontSize: '16px' }}>
                                        {formatAmount(monthlyPaymentInGracePeriod2)}
                                        &nbsp;֏
                                    </span>
                                </Col>
                                <Col className='my-auto px-2'>
                                    <span style={{ fontWeight: 'bold', color: '#191d21', fontSize: '16px' }}>
                                        {gracePeriod.gracePeriodForLoanAmount + 1}
                                    </span>
                                    -րդ ամսից&nbsp;
                                    <span style={{ fontWeight: 'bold', color: '#191d21', fontSize: '16px' }}>
                                        {formatAmount(monthlyPaymentAfterGracePeriod)}
                                        &nbsp;֏
                                    </span>
                                </Col>
                            </>
                        ) : (
                            <Col style={{ fontWeight: 'bold', color: '#191d21', fontSize: '16px' }} className='my-auto px-2'>
                                <AMD value={monthlyPaymentAfterGracePeriod || 0}/>
                            </Col>
                        )}
                    </Row>
                    <Row className='border-b table-row' justify='space-between'>
                        <Col className='my-auto px-2'>Փաստացի տոկասադրույք</Col>
                        <Col style={{ fontWeight: 'bold', color: '#191d21', fontSize: '16px' }} className='my-auto px-2'>
                            {effectiveRate ? `${effectiveRate}%` : '-'}
                        </Col>
                    </Row>
                </div>
            </div>
        </Card>
    )
};

Conditions.propTypes = {};

export default Conditions;